/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useState } from 'react';

export const getAllItems = () => {
  const items = {} as any;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key) {
      items[key] = localStorage.getItem(key) || '';
    }
  }
  return items;
};

export const useLocalStorage = <T>(
  key: string,
  defaultValue: T | null = null,
): [T | null, (value: T | null) => void] => {
  const [storedValue, setStoredValue] = useState<T | null>(() => {
    try {
      return getItemFromLocalStorage(key, defaultValue);
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = useCallback(
    (value: T | null) => {
      localStorage.setItem(key, JSON.stringify(value));
      setStoredValue(value);
    },
    [key],
  );

  return [storedValue, setValue];
};

export const getItemFromLocalStorage = <T>(key: string, defaultValue: T | null = null) => {
  const allItems = getAllItems();

  const value = Object.entries(allItems).find(([keyItem, valueItem]) => {
    if (keyItem.includes(key)) {
      return valueItem;
    }
  });

  if (value && value.length > 0) {
    const result = JSON.parse(value[1] as string) as T | null;
    return result;
  }

  return defaultValue;
};
